import { h } from 'preact';
import Store from 'store/store';
import { getThundrData, getCopy, getAccessibilityCopy } from 'utils/thundr';
import { isPlaceholder } from 'utils/data';
import { getMovieStatus } from 'utils/movieStatus';
import { getCurrentRegionSettings } from 'utils/studioConfig';

import EditorContent from 'components/editor/content';

export default class MovieEditor extends EditorContent {
	get movie() {
		return {
			...this.props.content, // Use merged content for visual display
			id: this.props.data?.id,
			base_movie_id: this.props.data?.base_movie_id,
			placeholder: isPlaceholder(this.props.data),
			status: this.state.status,
		};
	}

	get homeEntEnabled() {
		const regionSettings = getCurrentRegionSettings();
		return !!regionSettings?.homeEnt;
	}

	constructor(props) {
		super(props);

		this.state = {
			status: Store.get().movieStatuses?.[this.props.data?.id],
			thundrData: {},
		};
	}

	componentDidMount() {
		super.componentDidMount?.();

		this.updateMovieStatus();
		this.loadThundrData();
	}

	componentDidUpdate(prevProps) {
		super.componentDidUpdate?.(prevProps);

		if (prevProps.data !== this.props.data) {
			this.updateMovieStatus();
		}
	}

	async loadThundrData() {
		const thundrData = await getThundrData(this.props.data);
		this.setState({ thundrData });
	}

	async updateMovieStatus() {
		const status = await getMovieStatus(this.props.data);
		this.setState({ status });
	}

	text(value, defaultValue) {
		return getCopy(this.state.thundrData, value) || getAccessibilityCopy(this.state.thundrData, value) || defaultValue || value;
	}

	navigateToMedia() {
		const movieId = this.movie?.base_movie_id || this.movie?.id;
		if (movieId) window.location.hash = `movies/${movieId}/media`;
	}
}